import React from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from '../../components/LoaderScreen';
import { useEffect, useState } from 'react';
import request from '../../../Helpers/API';
import { GetMonthNameByNumber } from "../../Finanzas/Helper/GetMonthNameByNumber";
import Swal from "sweetalert2";
import { useBox } from "../../Finanzas/Helper/useBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PolizasDuplicadasSection } from "./PolizasDuplicadasSection";
import { VentasInternasSection } from "./VentasInternasSection";
import { DescuentosNoTimbradosSection } from "./DescuentosNoTimbradosSection";
import { FacturacionNoRegistradaSection } from "./FacturacionNoRegistradaSection";
import { FacturacionSinUIDSection } from "./FacturacionSinUIDSection";
import { TitulosSection } from "./TitulosSection";
import FiltroFiscal from "../FiltroFiscal";
import { ReversasUUIDVigente } from "./ReversasUUIDVigente";
import { DescuentosTimbradosVentasSection } from "./DescuentosTimbradosVentasSection";
import { CancelacionesSATVigentesEQUIPSection } from "./CancelacionesSATVigentesEQUIPSection";
import { ReversasPendientesAplicarSection } from "./ReversasPendientesAplicarSection";
import { RegistrosCandidatosRefacturacionSection } from "./RegistrosCandidatosRefacturacionSection";
import { AnticiposNoLigadosSection } from "./AnticiposNoLigadosSection";
import { NotasNoTimbradosSection } from "./NotasNoTimbradosSection";
import { NotasSinRelacionSection } from "./NotasSinRelacionSection";
import { AnticiposSinUUIDSection } from "./AnticiposSinUUIDSection";
import { AnticiposMultiplesNotasSection } from "./AnticiposMultiplesNotasSection";

export const ListadoInvoiceMovimientosScreen = () => {
  const history = useHistory();
  const [invoice, setInvoice] = useState([]);
  const [ventasInternas, setVentasInternas] = useState([]);
  const [descuentos, setDescuentos] = useState([]);
  const [descuentosComoVentas, setDescuentosComoVentas] = useState([]);
  const [facturacion, setFacturacion] = useState([]);
  const [facturacionSinUUID, setFacturacionSinUUID] = useState([]);
  const [reversas, setReversas] = useState([]);
  const [cancelacionesSATVigentes, setCancelacionesSATVigentes] = useState([]);
  const [reversasPendientesAplicar, setReversasPendientesAplicar] = useState([]);
  const [candidatosRefacturacion, setCandidatosRefacturacion] = useState([]);
  const [anticiposNoLigados, setAnticiposNoLigados] = useState([]);
  const [anticiposSinUUID, setAnticiposSinUUID] = useState([]);
  const [anticiposMultiplesNotas, setAnticiposMultiplesNotas] = useState([]);
  const [notasNoTimbradas, setNotasNoTimbradas] = useState([]);
  const [notasSinRelacion, setNotasSinRelacion] = useState([]);

  const [botones, setBotones] = useState([]);
  const [boxstate, setBoxState] = useBox();
  const [titulo, setTitulo] = useState('CORRECCION INCIDENCIAS');
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });


  useEffect(() => {
    const fechaActual = new Date();
    const ejercicioActual = fechaActual.getFullYear();
    const mesActual = fechaActual.getMonth() + 1;
    boxstate.ejercicio = ejercicioActual;
    boxstate.periodo = mesActual;
    onExecute(boxstate.ejercicio, boxstate.periodo, null, 'C');
  }, []);

  const onExecute = (ejercicio, periodo, tipo, origen = 'C') => {
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });

      if (origen === 'A') {
        request
          .get(`ListadoInvoiceMoviemientos/ObtenerListadosCorreccionIncidenciasAnticipos?ejercicio=${ejercicio}&periodo=${periodo}&origen=${origen}`)
          .then((result) => {
            setLoader({ ...loader, mostrar: false });
            setInvoice([]);
            setVentasInternas([]);
            setDescuentos([]);
            setDescuentosComoVentas([]);
            setFacturacion([]);
            setFacturacionSinUUID([]);
            setReversas([]);
            setCancelacionesSATVigentes([]);
            setReversasPendientesAplicar([]);
            setCandidatosRefacturacion([]);
            setAnticiposNoLigados(result.anticipos_NoLigados ?? []);
            setAnticiposSinUUID(result.anticipos_SinUUID ?? []);
            setAnticiposMultiplesNotas(result.anticipos_Multiples_Notas ?? []);
            setNotasNoTimbradas(result.notas_NoTimbradas_ComoEgreso ?? []);
            setNotasSinRelacion(result.notas_SinRelacion ?? []);
            const mes = GetMonthNameByNumber(boxstate.periodo).toUpperCase();
            setTitulo(`CORRECCION DE INCIDENCIAS ${mes} ${boxstate.ejercicio}`);
            return;
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("DASHBOARD FISCAL", JSON.stringify(error), "error");
            return;
          });
        return;
      }

      request
        .get(`ListadoInvoiceMoviemientos/ObtenerListadosCorreccionIncidencias?ejercicio=${ejercicio}&periodo=${periodo}&origen=${origen}`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setInvoice(result.invoice);
          setVentasInternas(result.ventas_Internas);
          setDescuentos(result.descuentos_Notimbrados);
          setDescuentosComoVentas(result.descuentos_Timbrados_Ventas);
          setFacturacion(result.facturacion_NoRegistrada);
          setFacturacionSinUUID(result.facturación_SinUuid);
          setReversas(result.reversas);
          setCancelacionesSATVigentes(result.cancelacionesSat_VigentesEQUIP);
          setReversasPendientesAplicar(result.reversas_Pendientes_Aplicar);
          setCandidatosRefacturacion(result.candidatos_Refacturacion);
          setAnticiposNoLigados([]);
          setAnticiposSinUUID([]);
          setAnticiposMultiplesNotas([]);
          setNotasNoTimbradas([]);
          setNotasSinRelacion([]);
          setBotones(result.botones);
          const mes = GetMonthNameByNumber(boxstate.periodo).toUpperCase();
          setTitulo(`CORRECCION DE INCIDENCIAS ${mes} ${boxstate.ejercicio}`);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          // reject(error);
          Swal.fire("DASHBOARD FISCAL", JSON.stringify(error), "error");
          // console.log(error)
          return;
        });
    });
  };

  const invoicelength = new Set(invoice.map(i => i.batch)).size;

  return (
    <PlantillaScreen
      titulo={titulo}
      className_main={1}
      className={"listado-fiscal-invoicemovimientos-mainscreen"}
    >
      <LoaderScreen loader={loader} />
      <div className="listado-fiscal-invoicemovimientos-actions">
        <div
          className="listado-fiscal-invoicemovimientos-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="listado-fiscal-invoicemovimientos-actions-filtro">
          <FiltroFiscal
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            esfiscal={true}
            mostrarOrigen={true}
          />
        </div>
        {/* <div className="listado-fiscal-invoicemovimientos-actions-buttons">
          <button
            className="cancelaciones"
            // onClick={() => handleAplicar()}
          >
            Cancelaciones
          </button>
        </div> */}
      </div>
      <div className="listado-fiscal-invoicemovimientos-container-general scroll">
        {invoice.length > 0 && (
          <>
            <TitulosSection titulo={"POLIZAS DUPLICADAS"} contador={invoicelength} />
            <PolizasDuplicadasSection data={invoice} botones={botones} />
          </>
        )}
        {ventasInternas.length > 0 && (
          <>
            <TitulosSection titulo={"VENTAS INTERNAS CON UUID"} contador={ventasInternas.length} />
            <VentasInternasSection data={ventasInternas} />
          </>
        )}
        {descuentos.length > 0 && (
          <>
            <TitulosSection titulo={"DESCUENTOS TIMBRADOS COMO EGRESOS"} contador={descuentos.length} />
            <DescuentosNoTimbradosSection data={descuentos} />
          </>
        )}
        {descuentosComoVentas.length > 0 && (
          <>
            <TitulosSection titulo={"DESCUENTOS TIMBRADOS EN CUENTAS DE VENTAS"} contador={descuentosComoVentas.length} />
            <DescuentosTimbradosVentasSection data={descuentosComoVentas} />
          </>
        )}
        {facturacion.length > 0 && (
          <>
            <TitulosSection titulo={"FACTURACION NO REGISTRADA EN CUENTAS DE VENTAS"} contador={facturacion.length} />
            <FacturacionNoRegistradaSection data={facturacion} />
          </>
        )}
        {facturacionSinUUID.length > 0 && (
          <>
            <TitulosSection titulo={"FACTURACION SIN UUID"} contador={facturacionSinUUID.length} />
            <FacturacionSinUIDSection data={facturacionSinUUID} />
          </>
        )}
        {reversas.length > 0 && (
          <>
            <TitulosSection titulo={"REVERSAS CON UUID VIGENTE"} contador={reversas.length} />
            <ReversasUUIDVigente data={reversas} />
          </>
        )}
        {cancelacionesSATVigentes.length > 0 && (
          <>
            <TitulosSection titulo={"CANCELACIONES EN SAT VIGENTES EN EQUIP"} contador={cancelacionesSATVigentes.length} />
            <CancelacionesSATVigentesEQUIPSection data={cancelacionesSATVigentes} />
          </>
        )}
        {reversasPendientesAplicar.length > 0 && (
          <>
            <TitulosSection titulo={"REVERSAS PENDIENTES DE APLICAR"} contador={reversasPendientesAplicar.length} />
            <ReversasPendientesAplicarSection data={reversasPendientesAplicar} botones={botones} actualiza={() => onExecute(boxstate.ejercicio, boxstate.periodo)}/>
          </>
        )}
        {candidatosRefacturacion.length > 0 && (
          <>
            <TitulosSection titulo={"REGISTROS CANDIDATOS A SER REFACTURACIONES"} contador={candidatosRefacturacion.length} />
            <RegistrosCandidatosRefacturacionSection data={candidatosRefacturacion} botones={botones} actualiza={() => onExecute(boxstate.ejercicio, boxstate.periodo)}/>
          </>
        )}
        {notasNoTimbradas.length > 0 && (
          <>
            <TitulosSection titulo={"NOTAS NO TIMBRADAS COMO EGRESO"} contador={notasNoTimbradas.length} />
            <NotasNoTimbradosSection data={notasNoTimbradas} />
          </>
        )}
        {notasSinRelacion.length > 0 && (
          <>
            <TitulosSection titulo={"NOTAS SIN RELACION"} contador={notasSinRelacion.length} />
            <NotasSinRelacionSection data={notasSinRelacion} botones={botones} />
          </>
        )}
        {anticiposSinUUID.length > 0 && (
          <>
            <TitulosSection titulo={"ANTICIPOS SIN UUID"} contador={anticiposSinUUID.length} />
            <AnticiposSinUUIDSection data={anticiposSinUUID} botones={botones} />
          </>
        )}
        {anticiposMultiplesNotas.length > 0 && (
          <>
            <TitulosSection titulo={"CLIENTES CON CARGOS SUPERIORES A ABONOS"} contador={new Set(anticiposMultiplesNotas.map((r) => r.v_ref)).size} />
            <AnticiposMultiplesNotasSection data={anticiposMultiplesNotas} />
          </>
        )}

        {anticiposNoLigados.length > 0 && (
          <>
            <TitulosSection titulo={"ANTICIPOS NO LIGADOS A FACTURAS"} contador={anticiposNoLigados.length} />
            <AnticiposNoLigadosSection data={anticiposNoLigados} />
          </>
        )}

      </div>
    </PlantillaScreen>
  );
};
